import React from "react";
import {
  ClickAwayListener,
  makeStyles,
  Tooltip as MuiTooltip,
  withStyles,
} from "@material-ui/core";
import clsx from "clsx";
import TooltipContent from "./TooltipContent";

const HtmlTooltip = withStyles(() => ({
  arrow: {
    color: "#eeeff3",
    fontSize: 16,
  },
  tooltip: {
    backgroundColor: "#eeeff3",
    padding: 0,
    color: "#858997",
    maxWidth: "unset",
    borderRadius: 10,
  },
}))(MuiTooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
  },
  icon: {
    display: "inline-block",
    fontSize: "12px",
    color: "#a1a4ac",
    marginLeft: theme.spacing(1),
    cursor: "pointer",
  },
}));

export default function InfoIcon({
  text,
  portalMode = true,
}: {
  text: string;
  portalMode?: boolean;
}) {
  const [open, setOpen] = React.useState<boolean>(false);
  const classes = useStyles();

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className={classes.root}>
        <HtmlTooltip
          arrow
          interactive
          placement="top"
          PopperProps={{
            disablePortal: !portalMode,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <TooltipContent text={text} closeHandler={handleTooltipClose} />
          }
        >
          <div
            className={clsx(classes.icon, "wedu-icon-question")}
            onClick={handleTooltipToggle}
          />
        </HtmlTooltip>
      </div>
    </ClickAwayListener>
  );
}
